// @ts-nocheck
export const SELECT_MENU_PORTAL = 'select-menu-portal'
